import React, { useState } from 'react';
import {
  Box,
  Stack,
  // Dialog,
  // Tooltip,
  Popover,
  IconButton,
  Typography,
} from '@mui/material';
import Upvotes from '../../../components/Upvotes';
import { PersonAddAlt } from '@mui/icons-material';
import CallBookingModal from '../../CallBookingModal';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ChatAvatarComponent from '../ChatAvatarComponent';
// import instantCallEvent from "../../instantCallEvent";
// import LaunchZoomCall from "../../../../LaunchZoomCall";
// import Mute from '../../../../../assets/images/Mute.svg';
import Leave from '../../../../../assets/images/Leave.svg';
import { useAppSelector } from '../../../../../redux/hooks';
import { getUserDetails } from '../../../../../utils/orgName';
// import CallBookingCalendar from '../../CallBookingCalendar';
// import { useAppSelector } from "../../../../../redux/hooks";
// import { getUserDetails } from "../../../../../utils/orgName";
// import StarIcon from '../../../../../assets/images/starimage.png';
import ConfirmDialog from '../../../../../components/DialogUi/ConfirmDialog';
// import VideoIcon from '../../../../../assets/images/videoimage.png';
// import { alphaColors } from '../../../../../utils/alphabates-colors';
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ChatMainHeaderLoader } from '../../../../../Loader/chat/ChatLoader';
// import GroupChatUsers from '../../../../../assets/images/GroupChatUsers.svg';
import GroupDescription from '../../../../../assets/images/GroupDescription.svg';
import VideocamIcon from '@mui/icons-material/Videocam';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { useNavigate } from 'react-router-dom';
import { MOBILE_SX, useIsMobileApp } from '../../../../../mobile/mobileApp';
// import CommonModalHeader from '../../../../../components/DialogUi/CommonModalHeader';
// import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';

interface IChatMainHeader {
  chatType: string;
  activeChat: string;
  setChatInfoForm: React.Dispatch<boolean>;
  channelImage: string;
  acsChannelParticipants: any;
  handleAddPersonToThread: any;
  channel: any;
  isLoading: boolean;
  onClickOnUserIcon: () => void;
  setopenGroupDetails: any;
  removeParticipantFromThread: () => void;
  otherParticipantId?: string;
  otherParticipantRole?: string;
}

const ChatMainHeader: React.FC<IChatMainHeader> = ({
  acsChannelParticipants,
  activeChat: _activeChat,
  channelImage,
  chatType,
  handleAddPersonToThread,
  setChatInfoForm: _setChatInfoForm,
  channel,
  isLoading,
  onClickOnUserIcon,
  setopenGroupDetails,
  removeParticipantFromThread,
  otherParticipantId,
  otherParticipantRole
}) => {
  const bookedCallDetails: any = '';
  const selectedChatUser = useAppSelector((state) => state.selectedChatUser.data);
  const isMobileApp = useIsMobileApp();
  const navigate = useNavigate();
  // Phone: the conversation is its own screen; back returns to where it was opened from (the
  // list, or a profile's Message button). With nothing behind it in the app's history (a deep
  // link, even one resolved by a replace), back goes to the list rather than out of the app.
  const backToList = () =>
    (window.history.state?.idx ?? 0) > 0 ? navigate(-1) : navigate('/app/chat', { replace: true });
  const backButton = isMobileApp ? (
    <IconButton
      aria-label="Back to chats"
      data-testid="chat-back"
      onClick={backToList}
      sx={{ color: '#FDFDFD', flexShrink: 0 }}
    >
      <ArrowBackIosNewRoundedIcon sx={{ fontSize: 20 }} />
    </IconButton>
  ) : null;
  const handleBookIconClick = async (param: any) => {
    if (param === 'BookIcon') {
      // Perform specific action when param is equal to BookIcon
      setCalendarOpen(true);
    } else if (param === 'VideoIcon') {
      // const baseUrl = window.location.origin;
      // const meetingId = Math.random().toString(36).substr(2, 9);
      // const currentTimestamp = new Date().getTime();
      // const currentUnixTime = Math.floor(currentTimestamp / 1000);
      // const userName = getUserDetails().name;
      // instantCallEvent(channel, acsChannelParticipants, getUserDetails().communicationUserId, baseUrl, meetingId, currentUnixTime);
      // setZoomCallProps({
      //   base_url: baseUrl,
      //   meetingId: meetingId,
      //   unix_time: currentUnixTime,
      //   userName: userName
      // });
      // setCallActive(true);
    }
  };

  const [isCalendarOpen, setCalendarOpen] = useState(false);
  const handleCalendar = (flag: boolean) => setCalendarOpen(flag);

  /** Popover */
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  /** Popover end */

  const [openLeaveModal, setOpenLeaveModal] = React.useState(false);

  const handleClickOpenLeaveModal = () => {
    setOpenLeaveModal(true);
  };

  const handleCloseLeaveModal = () => {
    setOpenLeaveModal(false);
  };

  /** How many group members */
  const HowManyuUsers = () => {
    const numOfUsers = acsChannelParticipants.length;
    return (
      <Upvotes number={numOfUsers} icon={'group'} />
    );
  };

  return (
    isLoading ? (
      isMobileApp ? (
        <Box display="flex" alignItems="center" pl={0.5}>
          {backButton}
          <Box flex={1} minWidth={0}>
            <ChatMainHeaderLoader />
          </Box>
        </Box>
      ) : (
        <ChatMainHeaderLoader />
      )
    ) :
      <>
        <Box className="chat-v2__header">
          <Stack
            direction="row"
            className={chatType === 'Groups' ? 'cursor-pointer' : ''}
            gap={2}
            alignItems="center"
            sx={{ [MOBILE_SX]: { gap: 1, flex: 1, minWidth: 0 } }}
          // onClick={() => {
          //   if (activeChat === 'Groups') {
          //     setChatInfoForm(true);
          //   }
          // }}
          >
            <Box display="flex" alignItems="center" sx={{ [MOBILE_SX]: { flexShrink: 0 } }}>
              {backButton}

              <ChatAvatarComponent
                image={
                  selectedChatUser?.communicationId
                    ? channelImage
                      ? channelImage
                      : chatType !== 'Groups'
                        ? getUserDetails()?.picture
                        : channelImage
                    : channelImage
                      ? channelImage
                      : null
                }
                firstLetter={channel.slice(0, 1)}
                width={isMobileApp ? '40px' : undefined}
                height={isMobileApp ? '40px' : undefined}
                onClickOnUserIcon={() => {
                  onClickOnUserIcon();
                  if (chatType === 'Groups') {
                    setopenGroupDetails(true);
                  }
                }}
                type="noStatus"
              // onClickOnUserIcon={() => onClickOnUserIcon()}
              />
            </Box>
            <Stack spacing={0.5} sx={{ [MOBILE_SX]: { minWidth: 0 } }}>
              <Box>
                {/* Phone: a long name wraps rather than running under the Meeting button. */}
                <Typography
                  variant="h5"
                  data-testid="chat-recipient-name"
                  textTransform={'capitalize'}
                  className='cursor-pointer'
                  sx={{ [MOBILE_SX]: { overflowWrap: 'anywhere' } }}
                  onClick={() => {
                    onClickOnUserIcon();
                    if (chatType === 'Groups') {
                      setopenGroupDetails(true);
                    }
                  }}
                >
                  {selectedChatUser?.communicationId
                    ? channel
                      ? channel
                      : getUserDetails()?.firstName + ' ' + getUserDetails()?.lastName
                    : channel}
                </Typography>
              </Box>
              <Box className="chat-v2__status" onClick={() => (chatType === 'Groups' ? setopenGroupDetails(true) : null)}>
                {chatType === 'Groups' ? <HowManyuUsers /> : <Typography className="chat-v2__status-text">Available</Typography>}
              </Box>
            </Stack>
            {/* {chatType === 'Groups' ? <KeyboardArrowDownIcon fontSize="small" /> : null} */}
          </Stack>
          <Stack
            direction="row"
            className='cursor-pointer'
            alignItems="center"
            spacing={2}
            sx={{ [MOBILE_SX]: { flexShrink: 0, '& > :not(style) ~ :not(style)': { ml: 1 } } }}
          >
            {/* Add member icon */}
            {!selectedChatUser.communicationId &&
              (chatType === 'Groups' ? (
                <IconButton
                  disableRipple
                  onClick={handleAddPersonToThread}
                >
                  <PersonAddAlt color='primary' fontSize='small' />
                </IconButton>
              ) : null)}

            {/* Meeting btn */}
            {!selectedChatUser.communicationId && (
              <Box className="chat-v2__meeting-btn" onClick={() => handleBookIconClick('BookIcon')}>
                <Typography>Meeting</Typography>
                <VideocamIcon sx={{ width: 18, height: 18, color: '#FDFDFD' }} />
              </Box>
            )}

            {/* View more */}
            {chatType === 'Groups' ? (
              <Box m={'auto'}>
                <IconButton onClick={handleClick} disableRipple>
                  <MoreVertIcon color="primary" />
                </IconButton>
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                  }}
                >
                  <Box
                    className="PopoverListStyle"
                    onClick={() => {
                      if (chatType === 'Groups') {
                        setopenGroupDetails(true);
                        setAnchorEl(null);
                      }
                    }}
                  >
                    <img alt='' width="20px" height="20px" src={GroupDescription} />
                    <Typography>Group details</Typography>
                  </Box>
                  {/* <Box className='PopoverListStyle'>
                  <img width='20px' height='20px' src={Mute} />
                  <Typography> Mute Chat </Typography>
                </Box> */}
                  <Box className="PopoverListStyle" onClick={handleClickOpenLeaveModal}>
                    <img alt='' width="20px" height="20px" src={Leave} />
                    <Typography>Leave Group</Typography>
                  </Box>
                </Popover>
              </Box>
            ) : null}
          </Stack>
        </Box>

        {/* chat page booking modal */}
        <CallBookingModal
          handleCloseModal={() => handleCalendar(false)}
          openFlag={isCalendarOpen}
          chatProfileName={channel}
          threadParticipantsUsers={acsChannelParticipants}
          chatType={chatType}
          pageName="Chat"
          bookedCallDetails={bookedCallDetails}
          otherParticipantId={otherParticipantId}
          otherParticipantRole={otherParticipantRole}
        />

        {/* Leave Group Confirmation */}
        <ConfirmDialog
          open={openLeaveModal}
          onClose={handleCloseLeaveModal}
          onConfirm={() => {
            removeParticipantFromThread();
            handleCloseLeaveModal();
          }}
          title="Leave group"
          message="Are you sure you want to leave this group?"
          confirmLabel="Yes, leave"
        />

        {/* <Dialog open={isVideoCall} onClose={handleVideoCallClose} scroll="body">   
          <CommonModalHeader
            handleCloseModal={handleVideoCallClose}
            title={`Schedule Time with ${channel}`}
          />
          <ZoomCall/>
        </Dialog> */}
      </>
  );
};

export default ChatMainHeader;
